import React from 'react';
import { Col, Headline, Paragraph, Row, Span, Image, Button } from 'View/Common';
import { Section } from 'View/Container';
import { navigate, RouteComponentProps } from '@reach/router';
import Header from 'components/Header';
import { AudioSamples, Testimonials } from 'View/Component';
import { sealCustomers, headerImg, sleepingFreddy, arrow, video } from 'img/SleepPage';
import siegel from 'img/siegel_anerkannt_kassen.png';

import SleepPageStyle from './SleepPage.style';
import StoreButtons from 'components/StoreButtons';
import { ROUTES } from 'utils/typings/routes';

export const SleepPage: React.FC<RouteComponentProps> = (props) => {
  const { path } = props;
  const goToPricing = () => {
    navigate(ROUTES.ZPP_LANDING_PAGE);
  };

  return (
    <>
      <Header path={path} />
      <SleepPageStyle>
        <Section className="header-section">
          <Row>
            <Col xs={12} md={6} className="text-center">
              <Image src={headerImg} alt="Frau schläft" className="header-image" />
              <div className="d-none d-md-block d-lg-none">
                <Button title="Öffnet den entsprechenden Store zum Herunterladen der App" onClick={goToPricing}>
                  MEHR ERFAHREN
                </Button>
                <StoreButtons />
              </div>
            </Col>

            <Col xs={12} md={6} lg={5}>
              <Headline level={2}>
                Besser schlafen. <br /> Wissenschaftlich bestätigt.
              </Headline>
              <Paragraph>
                Rund 6 Millionen Menschen in Deutschland haben regelmäßig Schlafprobleme. Das kann zu Erschöpfung, Gereiztheit und sogar
                depressiven Verstimmungen führen.
              </Paragraph>
              <Paragraph>
                Mit <Span className="bold">7Schläfer</Span> findest du Schritt für Schritt zurück zum erholsamen Schlaf – mit einer Methode,
                die wissenschaftlich geprüft, natürlich und nachhaltig wirkt.
                <Span className="bold"> Damit du wieder ruhig einschlafen und erholt aufwachen kannst.</Span>
              </Paragraph>
              <Row>
                <Col className="button-row d-flex d-md-none d-lg-flex">
                  <Button className="cta-button" title="Öffnet den entsprechenden Store zum Herunterladen der App" onClick={goToPricing}>
                    MEHR ERFAHREN
                  </Button>
                  <StoreButtons />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="bottom-row-seals">
            <Col xs={6} md={6} lg={{ size: 5, offset: 1 }} className="col-left-seal">
              <Image src={sealCustomers} width={180} className="seal-customers" alt="Siegel Zufriedene Kunden" />
            </Col>
            <Col className="justify-content-end d-flex">
              <Image className="seal-health" src={siegel} width={135} />
            </Col>
          </Row>
        </Section>

        <AudioSamples />

        <Testimonials />

        <Section className="video-section" backgroundColor="c800" verticalPadding="medium">
          <Headline level={2} className="text-center">
            Schlafen leicht gemacht
          </Headline>
          <video width="100%" height="auto" controls>
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <Image src={sleepingFreddy} alt="Schlafender Freddy" className="freddy-image" />
        </Section>

        <Section className="cta-bottom text-center" verticalPadding="medium">
          <Row>
            <Col xs={12} md={{ size: 4, offset: 2 }}>
              <Button className="cta-button" title="Öffnet den entsprechenden Store zum Herunterladen der App" onClick={goToPricing}>
                JETZT LOSLEGEN
              </Button>
              <StoreButtons />
            </Col>
            <Col xs={12} md={4} lg={4} xl={3} className="d-flex justify-content-center justify-content-md-start">
              <Headline level={2}>Werde jetzt auch zum 7Schläfer!</Headline>
            </Col>
          </Row>
          <Image src={arrow} className="d-none d-md-flex mx-auto" />
        </Section>
      </SleepPageStyle>
    </>
  );
};
